// WO-33 — Piece 3: helpful empty screens (spec §4). A short title, one line of
// explanation and one primary button, centred where the list would be.
//
// Wrap a page's EXISTING empty message in this component:
//   <OnboardingEmptyState kind="contacts" to="/dashboard/crm">
//     ...the page's old empty message...
//   </OnboardingEmptyState>
// With the onboarding switch off, with an Arabic screen (no Arabic copy has been
// written yet), or when `when` is false, the old message renders untouched.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useOnboarding, OnboardingBoundary } from './OnboardingContext';
import { onboardingCopy, hasArabicCopy, pricingUrl } from './copy';
import { btnPrimary, panel, fontStyle } from './styles';

function Inner({ kind, to, src, onPrimary, onClear, variant, testId }) {
  const navigate = useNavigate();
  const text = onboardingCopy.en.empty[kind];
  if (!text) return null;

  const act = () => {
    if (kind === 'noResults' && onClear) { onClear(); return; }
    if (onPrimary) { onPrimary(); return; }
    if (src) { window.location.href = pricingUrl(src); return; }
    if (to) navigate(to);
  };

  const content = (
    <div className="flex flex-col items-center text-center" dir="ltr" lang="en" style={fontStyle}>
      <h3 className="text-lg font-semibold text-[#0F2D4E] dark:text-white">{text.title}</h3>
      <p className="mt-1 max-w-md text-sm text-[#4A5568] dark:text-muted-foreground">{text.text}</p>
      <button type="button" onClick={act} className={`${btnPrimary} mt-4`} data-testid={`onboarding-empty-${kind}-btn`}>
        {text.button}
      </button>
    </div>
  );

  if (variant === 'inline') {
    return <div className="py-2" data-testid={testId || `onboarding-empty-${kind}`}>{content}</div>;
  }
  return (
    <div className={`${panel} p-8 sm:p-12 transition-opacity duration-150`} data-testid={testId || `onboarding-empty-${kind}`}>
      {content}
    </div>
  );
}

export default function OnboardingEmptyState({ kind, when = true, children = null, ...rest }) {
  const onb = useOnboarding();
  const { language } = useLanguage();
  if (!onb.on || !when) return children;
  if (language === 'ar' && !hasArabicCopy()) return children;
  return (
    <OnboardingBoundary fallback={children}>
      <Inner kind={kind} {...rest} />
    </OnboardingBoundary>
  );
}
